import { useState } from 'react';
import './Tooltip.css';

const Tooltip = ({ text, className = '', children, direction = 'right' }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            className="tooltip-wrapper"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            {visible && (
                <span className={`tooltip-box tooltip-box--${direction} ${className}`}>
                    {text}
                    <div className={`tooltip-arrow tooltip-arrow--${direction}`} />
                </span>
            )}
        </div>
    );
};

export default Tooltip;